import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  mark() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    const viewed = JSON.parse(sessionStorage.getItem("viewedPostIds") || "[]")
    if (!viewed.includes(frame.id)) {
      viewed.push(frame.id)
      sessionStorage.setItem("viewedPostIds", JSON.stringify(viewed))
    }
  }
}
